/**
 * Copier identity. Copying is by invitation: WB5SKM issues each invite to a
 * known operator, so the callsign on a copy names the human who made it -
 * which is what an `ear-copy` reference has to carry (CORPUS.md section 3a).
 *
 * The check is loose on purpose. It accepts portable and prefixed calls
 * (VE3/W1ABC, W1ABC/P) and an SWL identifier, and rejects only what cannot
 * be an identifier at all. The invite is what vouches for the person.
 */
export const COPIER_ID = /^[A-Z0-9][A-Z0-9/-]{2,19}$/;
export function normalizeCopierId(raw) {
    return raw.trim().toUpperCase();
}
export function isValidCopierId(id) {
    return COPIER_ID.test(id) && /[0-9]/.test(id) && /[A-Z]/.test(id);
}
export const MAX_NAME_CHARS = 60;
//# sourceMappingURL=copier.js.map